/**
 * Кастомный FAQ-слайдер (вместо Swiper):
 * середина — центр, края — flush с отступом от стрелок, стрелки ±1 с доводкой до края.
 * <1024 — accordion.
 */

const DESKTOP_MIN = 1024
const EDGE_PAD = 56
const ARROW_STEP = 1
const EDGE_SNAP = 80

document.addEventListener('DOMContentLoaded', () => {
  const roots = [...document.querySelectorAll('.faq-slider')]
  if (!roots.length) return

  /** @type {Map<Element, { destroy: () => void, refresh: () => void } | null>} */
  const desktops = new Map()
  let accordionOn = false

  const isDesktop = () => window.innerWidth >= DESKTOP_MIN

  const sync = () => {
    if (isDesktop()) {
      if (accordionOn) {
        destroyAccordion(roots)
        accordionOn = false
      }
      roots.forEach((root) => {
        const existing = desktops.get(root)
        if (!existing) {
          desktops.set(root, initCustomFaqSlider(root))
        } else {
          existing.refresh()
        }
      })
    } else {
      roots.forEach((root) => {
        desktops.get(root)?.destroy()
        desktops.set(root, null)
      })
      if (!accordionOn) {
        initAccordion(roots)
        accordionOn = true
      }
    }
  }

  sync()
  window.addEventListener('resize', sync)
})

function initCustomFaqSlider(root) {
  const viewport = root.querySelector('.faq-slider__viewport')
  const track = root.querySelector('.faq-slider__track')
  const slides = [...(track?.querySelectorAll('.swiper-slide') || [])]
  const prevBtn = root.querySelector('.tab-prev')
  const nextBtn = root.querySelector('.tab-next')
  if (!viewport || !track || !slides.length) {
    return { destroy() {}, refresh() {} }
  }

  let active = Math.min(2, slides.length - 1)
  let currentX = 0
  const last = slides.length - 1

  const calcX = (i) => {
    const vw = viewport.clientWidth
    const maxX = EDGE_PAD
    const minX = Math.min(EDGE_PAD, vw - track.scrollWidth - EDGE_PAD)
    if (i <= 0) return maxX
    if (i >= last) return minX
    const el = slides[i]
    const centered = -(el.offsetLeft - (vw - el.offsetWidth) / 2)
    if (centered <= minX + EDGE_SNAP) return minX
    if (centered >= maxX - EDGE_SNAP) return maxX
    return centered
  }

  const goTo = (i, instant = false) => {
    active = Math.max(0, Math.min(last, i))
    slides.forEach((el, idx) => {
      el.classList.toggle('swiper-slide-active', idx === active)
    })

    requestAnimationFrame(() => {
      const nextX = calcX(active)
      if (!instant && Math.abs(nextX - currentX) < 2) return
      currentX = nextX
      track.style.transition = instant ? 'none' : 'transform 0.3s ease'
      track.style.transform = `translate3d(${currentX}px,0,0)`
    })
  }

  const stepBy = (delta) => {
    if (delta > 0) {
      if (active >= last) return
      goTo(Math.min(last, active + delta))
      return
    }
    if (active <= 0) return
    goTo(Math.max(0, active + delta))
  }

  const onSlideClick = (idx) => () => goTo(idx)
  const slideHandlers = slides.map((el, idx) => {
    const fn = onSlideClick(idx)
    el.addEventListener('click', fn)
    return { el, fn }
  })

  const onPrev = (e) => {
    e.stopPropagation()
    stepBy(-ARROW_STEP)
  }
  const onNext = (e) => {
    e.stopPropagation()
    stepBy(ARROW_STEP)
  }

  const onArrowMouseDown = (e) => {
    e.preventDefault()
  }

  prevBtn?.addEventListener('click', onPrev)
  nextBtn?.addEventListener('click', onNext)
  prevBtn?.addEventListener('mousedown', onArrowMouseDown)
  nextBtn?.addEventListener('mousedown', onArrowMouseDown)

  goTo(active, true)

  return {
    refresh() {
      goTo(active, true)
    },
    destroy() {
      slideHandlers.forEach(({ el, fn }) => el.removeEventListener('click', fn))
      prevBtn?.removeEventListener('click', onPrev)
      nextBtn?.removeEventListener('click', onNext)
      prevBtn?.removeEventListener('mousedown', onArrowMouseDown)
      nextBtn?.removeEventListener('mousedown', onArrowMouseDown)
      track.style.transform = ''
      track.style.transition = ''
      slides.forEach((el) => el.classList.remove('swiper-slide-active'))
    },
  }
}

/** @type {AbortController | null} */
let accordionAbort = null

function initAccordion(roots) {
  accordionAbort?.abort()
  accordionAbort = new AbortController()
  const { signal } = accordionAbort

  roots.forEach((root) => {
    const items = [...root.querySelectorAll('.item')]
    items.forEach((item) => {
      const trigger = item.querySelector('.item__question-wrapper')
      const icon = item.querySelector('.icon img')
      if (!trigger) return

      trigger.addEventListener(
        'click',
        () => {
          const isOpen = item.classList.contains('is-open')
          items.forEach((i) => {
            i.classList.remove('is-open')
            const iIcon = i.querySelector('.icon img')
            if (iIcon) iIcon.src = '/img/svg/faq-plus.svg'
          })
          if (!isOpen) {
            item.classList.add('is-open')
            if (icon) icon.src = '/img/svg/faq-minus.svg'
          }
        },
        { signal },
      )
    })
  })
}

function destroyAccordion(roots) {
  accordionAbort?.abort()
  accordionAbort = null

  roots.forEach((root) => {
    root.querySelectorAll('.item').forEach((item) => {
      item.classList.remove('is-open')
      const icon = item.querySelector('.icon img')
      if (icon) icon.src = '/img/svg/faq-plus.svg'
    })
  })
}
